import styles from './CircularLoader.module.scss';

interface CircularLoaderProps {
  className?: string;
}

export function CircularLoader({ className }: CircularLoaderProps) {
  return (
    <svg
      className={`${styles.loader} ${className || ''}`}
      viewBox="0 0 280 340"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 16 bars arranged in a circle */}
      <rect className={styles.loader__bar1} x="135" y="70" width="10" height="30" rx="2" fill="#8B4513" />
      <rect className={styles.loader__bar2} x="165" y="80" width="10" height="25" rx="2" fill="#A0522D" />
      <rect className={styles.loader__bar3} x="188" y="102" width="10" height="35" rx="2" fill="#556B2F" />
      <rect className={styles.loader__bar4} x="198" y="132" width="10" height="28" rx="2" fill="#6B8E23" />
      <rect className={styles.loader__bar5} x="198" y="163" width="10" height="32" rx="2" fill="#D2B48C" />
      <rect className={styles.loader__bar6} x="188" y="193" width="10" height="26" rx="2" fill="#DEB887" />
      <rect className={styles.loader__bar7} x="165" y="215" width="10" height="30" rx="2" fill="#CD5C5C" />
      <rect className={styles.loader__bar8} x="135" y="225" width="10" height="24" rx="2" fill="#E97451" />
      <rect className={styles.loader__bar9} x="105" y="225" width="10" height="33" rx="2" fill="#8B7355" />
      <rect className={styles.loader__bar10} x="75" y="215" width="10" height="27" rx="2" fill="#A0826D" />
      <rect className={styles.loader__bar11} x="52" y="193" width="10" height="31" rx="2" fill="#9ACD32" />
      <rect className={styles.loader__bar12} x="42" y="163" width="10" height="25" rx="2" fill="#808000" />
      <rect className={styles.loader__bar13} x="42" y="132" width="10" height="29" rx="2" fill="#BC8F8F" />
      <rect className={styles.loader__bar14} x="52" y="102" width="10" height="34" rx="2" fill="#D2691E" />
      <rect className={styles.loader__bar15} x="75" y="80" width="10" height="26" rx="2" fill="#8FBC8F" />
      <rect className={styles.loader__bar16} x="105" y="70" width="10" height="32" rx="2" fill="#B8860B" />
    </svg>
  );
}
